import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCheckmark2Small: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCheckmark2Small"><Path fillRule="evenodd" clipRule="evenodd" d="M18.4111 7.90588L10.0487 17.4629L5.58582 12.9999L7.00003 11.5857L9.95132 14.537L16.906 6.58887L18.4111 7.90588Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCheckmark2Small;
